module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/large-self-10x20-200x1600.svg";